import "./customTable.styles.scss";
import { LuImagePlus } from "react-icons/lu";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { useContext, useState } from "react";
import { FormContext } from "../../context/form.context";
import { FormTypes } from "../../utils/formFactory";
import Popup from "reactjs-popup";
import DeleteModal from "../customForm/DeleteModal";

const CustomTable = ({ headers, ids, values, actions, dicts }) => {
  const { image, update, remove } = actions ?? {};
  const { setIsFormOpen, setFormType, setInitialFormdata, formType, updateDestinationId } =
    useContext(FormContext);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const HandleAddImageClick = (id) => {
    setFormType(FormTypes.DestinationImage);
    setInitialFormdata(FormTypes.DestinationImage, { destinationId: id });
    setIsFormOpen(true);
  };

  const HandleDestinationUpdate = (id, dict) => {
    setFormType(FormTypes.UpdateDestination);

    const t = { ...dict, destinationId: id };
    setInitialFormdata(FormTypes.UpdateDestination, t);
    setIsFormOpen(true);
  };

  const HandleCloseDeleteModel = (id) => {
    updateDestinationId(id)
    setIsOpenDelete(!isOpenDelete);
  };

  return (
    <>
      <div className="table">
        <div className="table__header">
          {headers?.map((item, index) => (
            <div key={index} className="table__cell table__cell--header">
              {item}
            </div>
          ))}
        </div>
        {dicts?.map((item, index) => (
          <div key={index} className="table__row">
            <div className="table__cell">{item.name}</div>
            <div className="table__cell">{item.location}</div>
            <div className="table__cell">{item.typeLabel}</div>
            <div className="table__cell">{item.difficultyLabel}</div>
            <div className="table__cell">{item.maxElevation}</div>
            {actions && (
              <div key={index} className="table__cell">
                {image && (
                  <i
                    className="table__action u-forestgreen"
                    title="add image"
                    onClick={() => HandleAddImageClick(item.id)}
                  >
                    <LuImagePlus />
                  </i>
                )}
                {update && (
                  <i
                    className="table__action"
                    title="update"
                    onClick={() => HandleDestinationUpdate(item.id, item)}
                  >
                    <FaRegEdit />
                  </i>
                )}
                {remove && (
                  <i
                    className="table__action u-indianred"
                    title="delete"
                    onClick={() => HandleCloseDeleteModel(item.id)}
                  >
                    <RiDeleteBinLine />
                  </i>
                )}

                {isOpenDelete && (
                  <Popup
                    open={isOpenDelete}
                    className="delete-model"
                    position="left center"
                  >
                    <DeleteModal
                      title={"Delete Destination"}
                      itemName={"Destination"}
                      formType={FormTypes.DeleteDestination}
                      handleIsOpen={HandleCloseDeleteModel}
                    />
                  </Popup>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default CustomTable;
